import RoutePath from "routes/utils";

const baseBase = '/users';

export default {
  list: new RoutePath(`${baseBase}/`),
  create: new RoutePath(`${baseBase}/create`),
  details: new RoutePath(`${baseBase}/:userId/edit/`),
}
